export default "__VITE_ASSET__DU_mpobD__"